module.exports = __webpack_public_path__ + "media/images/front/banner_premium_campaign_side-7db178fbfeeb811960af42f35de547a7.jpg";